<div class="controls">
  <!-- Row 1: Time + Progress -->
  <div class="row progress-row">
    <!-- Row 2: Controls -->
    <div class="row buttons-row" role="group" aria-label="Playback controls">
      <div
        class="icon-btn small"
        type="div"
        (click)="rewind()"
        aria-label="Rewind"
      >
        <span class="material-icons">fast_rewind</span>
      </div>
      <div
        class="icon-btn large"
        type="div"
        (click)="playing ? pause() : play()"
        aria-label="Play/Pause"
      >
        <!-- <span class="material-icons">{{
          playing ? 'pause' : 'play_arrow'
        }}</span> -->
        <nw-icon
          *ngIf="!playing"
          type="play_arrow"
          [size]="26"
          [color]="'#2b2b2b'"
        ></nw-icon>
        <nw-icon
          *ngIf="playing"
          type="pause"
          [size]="23"
          [color]="'#2b2b2b'"
        ></nw-icon>
      </div>
      <div
        class="icon-btn small"
        type="div"
        (click)="forward()"
        aria-label="Forward"
      >
        <span class="material-icons">fast_forward</span>
      </div>
      <!-- <button
        class="icon-btn small"
        type="button"
        (click)="rewind.emit()"
        aria-label="Rewind"
      >
        <span class="material-icons">fast_rewind</span>
      </button>
      <button
        class="icon-btn large"
        type="button"
        (click)="playing ? pause() : play()"
        aria-label="Play/Pause"
      >
        <span class="material-icons">{{
          playing ? 'pause' : 'play_arrow'
        }}</span>
      </button>
      <button
        class="icon-btn small"
        type="button"
        (click)="forward.emit()"
        aria-label="Forward"
      >
        <span class="material-icons">fast_forward</span>
      </button> -->
    </div>
    <div
      class="progress"
      role="slider"
      aria-valuemin="0"
      [attr.aria-valuemax]="duration"
      [attr.aria-valuenow]="currentTime"
      (click)="onProgressClick($event)"
    >
      <div class="line baseline"></div>
      <div class="line filled" [style.width.%]="progressPct"></div>
      <div class="knob" [style.left.%]="progressPct"></div>
    </div>
    <div class="time" aria-live="polite">
      {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
    </div>
  </div>
</div>
